import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { DropDownFormatter } from "../../Entities/DropDownFormatter.ts";
import * as authActions from '../../Redux/Auth/AuthActions';
import DropDown from "../DropDown/drop-down-component";
import DropDownItem from "../DropDown/drop-down-item-component";
import NotificationDropDown from "../DropDown/drop-down-notification-component";
import ThemeToggler from "../Theme/theme-toggeler-component";
import landingPageImage from '../../Assets/Logo0.png'
import { useEffect, useState } from "react";
import ModalNavbar from "./modal-navbar-component.js";

function Navbar(props) {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    let currentRoute = useSelector((state) => state.auth.currentRoute);
    const isAutoLogOut = props.isAutoLogOut;
    const [openNavigation, setOpenNavigation] = useState(true)

    const CheckExternalink = (link) =>{
        if(link.startsWith("http"))
            {
                window.location.href = link;
                return;
            }
    }

    const handleLogOut = async (e) => {
        e.preventDefault();
        dispatch(authActions.logout());
    };

    const handleElementRedirect = async (e) => {
        e.preventDefault();
        let path = e.target.value.split(',')[1];
        const redirectPath = path || '/home';
        console.log(redirectPath);
        CheckExternalink(path);
        dispatch(authActions.redirectScreen(redirectPath))
        navigate(redirectPath);
    }

    const handleRedirect = async (e) => {
        e.preventDefault();
        let path = e.target.value;
        const redirectPath = path || '/home';
        CheckExternalink(redirectPath);
        dispatch(authActions.redirectScreen(redirectPath))
        navigate(redirectPath);
    }

    const email = localStorage.getItem('email') || '';
    const name = localStorage.getItem('name') || '';
    // const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    // const loading = useSelector((state) => state.loading);

    const buttonDropDown =
        { logo: 'M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z' };

    const additionalInfo = [name, email];

    const headerDropdown = new DropDownFormatter([
        { id: 1, name: 'Profile', value: '/profile' },
        { id: 2, name: 'Account', value: '/account' }], handleElementRedirect
    );

const bodyDropdown = new DropDownFormatter([
        { id: 2, name: 'Contact Us', value: '/contact', logo: 'M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z' },
    ], handleElementRedirect);

const bottomDropdown = new DropDownFormatter(
        [{ id: 1, name: 'Logout', value: '/landing' }], handleLogOut
    );

const headerNavBar = [
        { id: 1, name: 'Home', value: '/home' },
        { id: 3, name: 'Courses', value: '/courses' },
        { id: 4, name: 'Terms', value: '/terms' },
        { id: 6, name: 'Privacy', value: '/privacy' },
        { id: 5, name: 'Contact Us', value: '/contact' },
        { id: 2, name: 'Poll', value: '/poll' },
        { id: 7, name: 'Rate Us', value: 'https://forms.zohopublic.com/trunkmanagergm1/form/FeedbackForm/formperma/g8Ze2PBVchtKeV1ng_qajrdosbKP2ikCWB6SR4k48qU' },
        // { id: 2, name: 'Editor', value: '/editor' },
    ];
    const mciroNavFormatter = new DropDownFormatter(headerNavBar);

    return (

        <nav className="bg-white border-gray-200 px-4 lg:px-6 py-2.5 dark:bg-black">
            <div className="mx-auto w-full px-2 sm:px-6 lg:px-8">
                <div className="relative flex h-16 items-center justify-between">
                    <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                        <ModalNavbar formatter={mciroNavFormatter} onTrigger={handleElementRedirect} />
                    </div>
                    <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
                        <button className="flex flex-shrink-0 items-center hover:cursor-pointer" value='/home' onClick={handleRedirect}>
                            <img className="block h-8 w-auto lg:hidden dark:invert" src={landingPageImage} alt="Sawpy" />
                            <img className="hidden h-8 w-auto lg:block dark:invert" src={landingPageImage} alt="Sawpy" />
                        </button>
                        <div className="hidden sm:ml-6 sm:block">
                            <div className="flex space-x-4">
                                {headerNavBar.map((elem) => (
                                    <button
                                        key={elem.id}
                                        className={`${elem.value === currentRoute ? 'dark:bg-blue-600 bg-blue-700 text-white  dark:hover:font-medium' : 'text-gray-400'}  hover:bg-gray-400 hover:text-white dark:hover:bg-gray-600 dark:hover:text-white px-3 py-2 rounded-md text-sm font-medium hover:cursor-pointer transition-all`}
                                        value={elem.value}
                                        onClick={handleRedirect}>
                                        {elem.name}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                        <div className="p-2 mr-1">
                            <ThemeToggler />
                        </div>
                        {/* <NotificationDropDown /> */}
                        <DropDown buttonDrop={buttonDropDown}
                            infoDrop={additionalInfo}
                            headerDrop={headerDropdown}
                            bodyDrop={bodyDropdown}
                            bottomDrop={bottomDropdown}
                            isAutoLogOut={isAutoLogOut}
                        />
                    </div>
                </div>
            </div>
        </nav >
    );
}

export default Navbar;